import React, { useState, useEffect } from 'react';
import StatusDonutChart from './StatusDonutChart';
import TransporterBarChart from './TransporterBarChart';
import HourlyTrafficChart from './HourlyTrafficChart';
import DockUtilizationChart from './DockUtilizationChart';
import { subscribeToDailyStats } from '../../services/business/dashboardService';

const DashboardCharts = ({ tenantId, scope }) => {
    const [data, setData] = useState({
        statusBreakdown: [],
        transporterStats: [],
        hourlyTraffic: [],
        dockUtilization: [],
        totalVehicles: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!tenantId) return;
        setLoading(true);

        const unsubscribe = subscribeToDailyStats(tenantId, (stats) => {
            setData(stats);
            setLoading(false);
        }, scope);

        return () => unsubscribe();
    }, [tenantId, scope]);

    if (loading) {
        return <div className="p-4 text-center text-secondary">Grafikler yükleniyor...</div>;
    }

    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: 'var(--spacing-lg)', marginBottom: 'var(--spacing-2xl)' }}>
            <div className="card-premium glow-blue" style={{ background: 'var(--bg-card)', borderColor: 'var(--border-color)', padding: 'var(--spacing-xl)', borderRadius: 'var(--radius-xl)' }}>
                <StatusDonutChart data={data.statusBreakdown} totalCount={data.totalVehicles} />
            </div>

            <div className="card-premium glow-green" style={{ background: 'var(--bg-card)', borderColor: 'var(--border-color)', padding: 'var(--spacing-xl)', borderRadius: 'var(--radius-xl)' }}>
                <TransporterBarChart data={data.transporterStats} />
            </div>

            <div className="card-premium glow-red" style={{ background: 'var(--bg-card)', borderColor: 'var(--border-color)', padding: 'var(--spacing-xl)', borderRadius: 'var(--radius-xl)' }}>
                <HourlyTrafficChart data={data.hourlyTraffic} />
            </div>

            <div className="card-premium glow-purple" style={{ background: 'var(--bg-card)', borderColor: 'var(--border-color)', padding: 'var(--spacing-xl)', borderRadius: 'var(--radius-xl)' }}>
                <DockUtilizationChart data={data.dockUtilization} />
            </div>
        </div>
    );
};

export default DashboardCharts;
